import React from "react"
export function Lock(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M9.958 2a4.432 4.432 0 014.425 4.196l.006.236v1.182h.93c.652 0 1.181.529 1.181 1.181v8.273c0 .653-.529 1.182-1.182 1.182H4.682c-.653 0-1.182-.53-1.182-1.182V8.795c0-.652.53-1.181 1.182-1.181h.843V6.432A4.432 4.432 0 019.959 2zm4.77 7.386H5.272v7.091h9.454v-7.09zm-4.77 1.773a1.773 1.773 0 110 3.546 1.773 1.773 0 010-3.546zm0-7.386A2.66 2.66 0 007.305 6.25l-.006.182-.002 1.182h5.319V6.432a2.66 2.66 0 00-2.658-2.66z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__lock"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
